var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyState, Table } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import { TableFailedRow } from 'components/shared/tableFailedRow';
import { TableLoadingRow } from 'components/shared/tableLoadingRow';
import { TEAM_NUMBER_OF_COLUMNS } from '../teamPage';
import { TeamPageTableRow } from '../teamTableRow';
export class TeamList extends PureComponent {
    listPresence(userPresence) {
        const { appPresence, agentsDetail, profile, favouriteTeamMemberIds, transferToQueueModalOpen, toggleAgentDetails, } = this.props;
        const agentId = userPresence.agent_id;
        const isOwnAgent = profile.id === agentId;
        const isFavorite = favouriteTeamMemberIds.includes(agentId);
        const toggleFavorite = isFavorite
            ? () => {
                this.props.personalRemoveFromFavouriteTeamMemberIds({ agentId });
                analytics.teamFavoriteToggled({ value: false });
            }
            : () => {
                this.props.personalAddToFavouriteTeamMemberIds({ agentId });
                analytics.teamFavoriteToggled({ value: true });
            };
        return (_jsx(TeamPageTableRow, { isFavorite: isFavorite, showUserModal: this.props.showUserModal, userPresence: userPresence, isOwnAgent: isOwnAgent, profileId: profile.id, appPresence: appPresence, limits: this.props.limits, isMicrophoneBlocked: this.props.isMicrophoneBlocked, twilioMakeInternalCall: this.props.twilioMakeInternalCall, conversationsOverviewGetMessages: this.props.conversationsOverviewGetMessages, isOpen: !!agentsDetail[agentId], onFavoriteClick: toggleFavorite, toggleAgentDetails: toggleAgentDetails, transferToQueueModalOpen: transferToQueueModalOpen, getPresence: this.props.getPresence }, agentId));
    }
    renderLoadingStatus() {
        const { presence } = this.props;
        if (presence.itemsAsyncStatus === 'failed') {
            return _jsx(TableFailedRow, { colSpan: TEAM_NUMBER_OF_COLUMNS });
        }
        return _jsx(TableLoadingRow, { colSpan: TEAM_NUMBER_OF_COLUMNS });
    }
    render() {
        const { presence } = this.props;
        if (presence.itemsAsyncStatus !== 'succeeded') {
            return this.renderLoadingStatus();
        }
        return presence.items.length > 0 ? (presence.items.map(this.listPresence)) : (_jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: TEAM_NUMBER_OF_COLUMNS }, { children: _jsx(EmptyState, { title: "No agents found", description: "Try to change some filters, or try searching for another name." }) })) }));
    }
}
__decorate([
    boundMethod
], TeamList.prototype, "listPresence", null);
